import { render, staticRenderFns } from "./button-action-ribbon-split.vue?vue&type=template&id=492b2624&scoped=true&"
import script from "./button-action-ribbon-split.vue?vue&type=script&lang=js&"
export * from "./button-action-ribbon-split.vue?vue&type=script&lang=js&"
import style0 from "./button-action-ribbon-split.vue?vue&type=style&index=0&id=492b2624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b2624",
  null
  
)

export default component.exports